module.exports = __webpack_public_path__ + "media/tycho2t3_80_grey_pz.762afe05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/sky_box/tycho2t3_80_grey_pz.jpg
// module id = 1099
// module chunks = 0